import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import styles from './styles.module.scss'

export enum TypeBgCheckBox {
  WHITE = 'bgWhite',
  LIGHT_GRAY = 'bgLightGray',
}

export interface ISelectHandler {
  title: string
  name: string
}

interface Props {
  buttons: ISelectHandler[]
  active?: string
  bgColor?: TypeBgCheckBox
  onChange(data: ISelectHandler): void
}

export const ButtonCheckBox = ({
  buttons,
  active,
  bgColor = TypeBgCheckBox.LIGHT_GRAY,
  onChange,
}: Props) => {
  const { t } = useTranslation()

  const onChangeHandler = (data: ISelectHandler) => {
    if (data.name !== active) {
      onChange(data)
    }
  }

  return (
    <div className={clsx(styles.container, styles[bgColor])}>
      {buttons.map((item) => (
        <button
          key={'check' + item.name}
          onClick={() => onChangeHandler(item)}
          className={clsx(
            styles.button,
            active === item.name ? styles.activeButton : styles.inActiveButton,
          )}
        >
          {t(item.title)}
        </button>
      ))}
    </div>
  )
}
